import React from 'react';

import icons from './../../../icons.svg';

const CalibrationActions = ({ t, startCalibration, endCalibration }) => {
  return (
    <div className="calibration__actions">
      <div className="calibration__actions-start" onClick={startCalibration}>
        <svg>
          <use xlinkHref={`${icons}#icon-balance-scale`} />
        </svg>
        {t('cabinet:door_unlock')}
      </div>
      <div className="calibration__actions-start" onClick={endCalibration}>
        <svg>
          <use xlinkHref={`${icons}#icon-balance-scale`} />
        </svg>
        {t('cabinet:door_lock')}
      </div>
    </div>
  );
};

export default CalibrationActions;
